// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__6u1jv","resendInfoText":"OnGoingPaymentBox_resendInfoText__19fLh"};